/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Models_TitleInputs */

const en_seo_models_title = /** @type {(inputs: Seo_Models_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Models`)
};

const zh_seo_models_title = /** @type {(inputs: Seo_Models_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 模型对比`)
};

/**
* | output |
* | --- |
* | "AI Models" |
*
* @param {Seo_Models_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const seo_models_title = /** @type {((inputs?: Seo_Models_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Models_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seo_models_title(inputs)
	return zh_seo_models_title(inputs)
});
export { seo_models_title as "seo.models.title" }